document.addEventListener( 'DOMContentLoaded', function() {
  // Select all elements with the class 'e-acc__itm-wrpr'
  const tabs = document.querySelectorAll( '.e-acc__itm-wrpr' );
  // Loop through all elements and add click event listener
  tabs.forEach( function( tab ) {
    tab.addEventListener( 'click', function() {
      // Remove 'thumb-active' class from all tabs
      tabs.forEach( function( t ) {
        t.classList.remove( 'thumb-active' );
      } );
      // Add 'thumb-active' class to the clicked tab
      this.classList.add( 'thumb-active' );
    } );
  } );
} );

  